import 'regenerator-runtime/runtime';
import {
  call, put, fork, takeEvery,
} from 'redux-saga/effects';
import { parseError } from 'logic/helpers';
import api from 'api';
import * as actionCreators from './actionCreators';
import * as actions from './actions';

function* fethPaymentProductsRequest(req) {
  try {
    const { cottageId } = req.payload;
    const options = yield call(api.fetchPaymentProducts.bind(null, cottageId));

    yield put(actionCreators.fetchPaymentProductsSuccess({ options }));
  } catch (e) {
    yield put(actionCreators.fetchPaymentProductsFailure(parseError(e)));
  }
}

function* postPaymentPay(req) {
  try {
    const {
      cottageId,
      orderId,
      source,
      amount,
    } = req.payload;

    const data = { amount, source };

    const order = yield call(api.postPaymentPay.bind(null, cottageId, orderId, data));
    yield put(actionCreators.postPaymentPaySuccess({ order }));
  } catch (e) {
    yield put(actionCreators.postPaymentPayFailure(parseError(e)));
  }
}

function* postPaymentOrderRequest(req) {
  try {
    const {
      callback,
      cottageId,
      productIds,
      skipFetchSecret,
    } = req.payload;

    const order = yield call(api.postPaymentOrder.bind(null, cottageId, { productIds }));

    if (order.amount === 0) {
      yield call(postPaymentPay.bind(null, {
        payload: {
          cottageId,
          amount: order.amount,
          orderId: order.id,
          source: 'zero',
        },
      }));
    } else if (skipFetchSecret) {
      yield put(actionCreators.postPaymentOrderSuccess({ order }));
      yield callback();
    } else {
      const secret = yield call(api.fetchPaymentClientSecret.bind(null, cottageId, order.id));

      yield put(actionCreators.postPaymentOrderSuccess({ order }));
      yield callback(secret.client_secret);
    }
  } catch (e) {
    yield put(actionCreators.postPaymentOrderFailure(parseError(e)));
  }
}

function* fetchPaymentOrderRequest(req) {
  try {
    const { orderId, source } = req.payload;
    const order = yield call(api.fetchPaymentOrder.bind(null, orderId));
    const isPaid = !!order?.paid_at || String(order?.payment_status || '').toLowerCase() === 'paid';

    yield put(actionCreators.fetchPaymentOrderSuccess({ order }));

    // Stripe Checkout return: fast-path to Done if paid and skip /pay call
    if (source === 'stripe_checkout') {
      if (isPaid) {
        // Flip to Done first to avoid any UI flicker/races
        yield put(actionCreators.paymentSetActiveStep({ activeStep: 2 }));
      }
      // Always publish the order to the store
      yield put(actionCreators.fetchPaymentOrderSuccess({ order }));
      return; // never invoke /pay for checkout source
    }

    if (source) {
      const { amount } = order;
      yield call(postPaymentPay.bind(null, { payload: { ...req.payload, amount } }));
    }
  } catch (e) {
    yield put(actionCreators.fetchPaymentOrderFailure(parseError(e)));
  }
}

function* postPaymentInvoiceRequest(req) {
  try {
    const { cottageId, orderId, data } = req.payload;

    yield call(api.postPaymentInvoice.bind(null, cottageId, orderId, data));
    yield put(actionCreators.postPaymentInvoiceSuccess());
  } catch (e) {
    yield put(actionCreators.postPaymentInvoiceFailure(parseError(e)));
  }
}

function* fetchOrdersRequest(req) {
  try {
    const nextPageUrl = req.payload.nextPage;

    const { results, nextPage } = nextPageUrl
      ? (yield call(api.fetchNextPage.bind(null, nextPageUrl)))
      : (yield call(api.fetchOrders.bind(null, req.payload)));

    yield put(actionCreators.fetchOrdersSuccess({ list: results, nextPage }));
  } catch (e) {
    yield put(actionCreators.fetchOrdersFailure(parseError(e)));
  }
}

export default [
  fork(takeEvery, actions.FETCH_PAYMENT_PRODUCTS_REQUEST, fethPaymentProductsRequest),
  fork(takeEvery, actions.POST_PAYMENT_ORDER_REQUEST, postPaymentOrderRequest),
  fork(takeEvery, actions.POST_PAYMENT_PAY_REQUEST, postPaymentPay),
  fork(takeEvery, actions.FETCH_PAYMENT_ORDER_REQUEST, fetchPaymentOrderRequest),
  fork(takeEvery, actions.POST_PAYMENT_INVOICE_REQUEST, postPaymentInvoiceRequest),
  fork(takeEvery, actions.FETCH_ORDERS_REQUEST, fetchOrdersRequest),
];
